export const API_ASSIGNED_USER_CONTACTS = '/assigned-user-contacts';
export const API_CMS_USER_CONTACTS = '/cms-user-contacts';
export const API_TOURS = '/tours';
export const API_DRAFT_TOURS = '/draft-tours';
export const API_ICON_SET = '/icon-set';
export const API_ITEM_INFO = '/item-info';
export const API_MEDIA = '/media';
export const API_SCENES = '/scenes';
export const API_PROMOTIONS = `/promotion`;
export const API_THEMES = '/theme';
export const API_TOUR_SOUND = `/tour-sound`;
export const API_TOUR_BG_SOUND = `/tour-sound/bg-sound`;
export const API_USER_CONTACTS = `/user-contacts`;
export const API_ADMIN_TOURS = '/admin/tours';
export const API_ADMIN_SCENES = '/admin/scenes';
export const API_ESTORE = `/estore`;
export const API_ADMIN_WEB_ROTATE = '/webrotate360';
export const API_ADMIN_INTEG_WEB_ROTATE = 'v1/integ/webrotate360';
export const API_ADMIN_POI_TEMPLATE = '/poi-templates';
export const API_BOT_CHATBOT = `/ext/v1/bots/agents/published`;
export const API_CHATBOT = '/chatbots';
